import * as React from "react";

export const SvgArrowRight = ({ color = "#595959", ...props }) => (
	<svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" color={color} {...props}>
		<path
			d="M12.5 8.343a.958.958 0 0 0-.282-.679L6.321 1.767a.96.96 0 1 0-1.358 1.358l5.218 5.218-5.218 5.218a.96.96 0 1 0 1.358 1.358l5.897-5.897a.957.957 0 0 0 .281-.679Z"
			fill="currentColor"
		/>
	</svg>
);
